import React, { useEffect, useState } from 'react';
import { useEvent, useMobileMenuContext } from 'contexts';
import {
    Cooperation,
    Intro,
    Stats,
    Universities,
    News,
    Events,
    Reviews,
    Outro,
} from './components';
import { Container, Hexa, MainContainer } from './styled';
import { langMapper } from 'utils';
import { useTranslation } from 'react-i18next';
import { getNewsApiService } from 'services';
import { NewsListItem } from 'types';
import { PaginationOutput } from 'kl-b2c-ui-kit';

export const AcademyAlliance: React.FC = (): JSX.Element => {
    const { toggleAcademyAllianceStyles } = useMobileMenuContext();
    const { i18n } = useTranslation('pages/academy-alliance');
    const API = getNewsApiService();
    const [news, setNews] = useState<PaginationOutput<NewsListItem>>();

    const { events, getList } = useEvent();
    const langDomain = langMapper[i18n.language];

    useEffect(() => {
        toggleAcademyAllianceStyles(true);

        getList({
            page: 0,
            size: 3,
            domainType: langDomain,
            showOnAlliance: true,
            orderByStartDate: false,
        });

        API.getNewsList({
            DomainType: langDomain,
            Page: 0,
            Size: 3,
            ShowOnAlliance: true,
        }).then((fetchedList) => {
            setNews(fetchedList);
        });

        return () => {
            toggleAcademyAllianceStyles(false);
        };
    }, []);

    return (
        <>
            <Container>
                <Intro />
                <Hexa />
            </Container>
            <Cooperation />
            <MainContainer>
                <Stats />
                <Universities />
                {events && events.count > 0 && <Events items={events.items} />}
                {news && news.count > 0 && <News items={news.items} />}
                <Reviews />
            </MainContainer>
            <Outro />
        </>
    );
};

export default AcademyAlliance;
